import React from "react";
import ReactDOM from "react-dom/client";
import { ClerkProvider } from "@clerk/react";
import { createBrowserHistory } from "@tanstack/react-router";

import "./index.css";

import { ManagedRelayAuthProvider } from "./cloud/managedAuth";
import { hasCloudPublicConfig } from "./cloud/publicConfig";
import { getRouter } from "./router";
import { AppRoot } from "./AppRoot";
import { clerkAppearance } from "./components/clerk/clerkAppearance";
import { markStartup } from "./startup/timing";

markStartup("entry");

const router = getRouter(createBrowserHistory());

const clerkPublishableKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY as string | undefined;

const app = <AppRoot router={router} />;
if (!clerkPublishableKey || !hasCloudPublicConfig()) {
  throw new Error("Maito account authentication is not configured.");
}

// Prerendered content supplies metadata before JavaScript loads; the router owns it after boot.
document.querySelectorAll("[data-maito-content-head]").forEach((element) => element.remove());

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <ClerkProvider appearance={clerkAppearance} publishableKey={clerkPublishableKey}>
      <ManagedRelayAuthProvider>{app}</ManagedRelayAuthProvider>
    </ClerkProvider>
  </React.StrictMode>,
);
